import PatientSelectionForm from '../components/Sessions/PatientSelectionForm';
import {useNavigate} from "react-router-dom";

const PatientSelectionPage = (props) => {
  const navigate = useNavigate();

  const onSelection = (value) => {
    navigate('/sessions/')
  }

  return (
    <section className={"page_content"}>
      <PatientSelectionForm onSelection={onSelection}/>
    </section>);
};

export default PatientSelectionPage;
